module.exports = import("https://widget.fitanalytics.com/integration_interface_esm.js");;